import React from 'react';
import { useContactDealer } from 'site-modules/shared/components/inventory/contact-dealer/contact-dealer';

export function PrivatePartyOverview() {
  const { vinData } = useContactDealer();
  const { address } = vinData.sellerInfo || {};

  return (
    <div className="dealer-overview border-top mt-1_5 pt-1_5">
      <div className=" fw-medium ">
        Private Seller - {address?.city}, {address?.stateCode}
      </div>
    </div>
  );
}
